import React from 'react';
import {
  Box,
  Typography,
  IconButton,
  Avatar,
  Stack,
} from '@mui/material';
import {
  ArrowForward as ArrowForwardIcon,
  Check as CheckIcon,
} from '@mui/icons-material';
import dayjs from 'dayjs';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

function MainAgendaListItem({ item, onClick, onEventClick, onPostpone, onComplete, dateTimeFormat = 'DD/MM/YYYY HH:mm' }) {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const handleEventClick = (e) => {
    if (onEventClick) {
      onEventClick(e, item);
    }
  };

  const handlePostponeClick = (e) => {
    e.stopPropagation();
    if (onPostpone) {
      onPostpone(item);
    }
  };

  const handleCompleteClick = (e) => {
    e.stopPropagation();
    if (onComplete) {
      onComplete(item);
    }
  };

  const handlePetClick = (e) => {
    e.stopPropagation();
    if (item.pet) {
      navigate('/main/view-pet', { state: { id: item.pet.id, updateLastView: false } });
    }
  };

  const handleOwnerClick = (e) => {
    e.stopPropagation();
    if (item.owner) {
      navigate('/main/view-owner', { state: { id: item.owner.id } });
    }
  };

  const formatDateTime = (dateTimeStr) => {
    return dayjs(dateTimeStr).format(dateTimeFormat);
  };

  const getThumbnailUrl = () => {
    if (item.product?.thumb_url) return item.product.thumb_url;
    if (item.owner?.thumb_url) return item.owner.thumb_url;
    if (item.pet?.name) return null;
    if (item.product?.name) return null;
    return null;
  };

  const getThumbnailFallback = () => {
    if (item.pet?.name) return item.pet.name.charAt(0);
    if (item.product?.name) return item.product.name.charAt(0);
    return '?';
  };

  return (
    <Box 
      onClick={handleEventClick}
      sx={{ 
        width: '100%', 
        py: 1,
        cursor: 'pointer',
        '&:hover': {
          backgroundColor: 'action.hover',
        },
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'flex-start', px: 1 }}>
        {/* Thumbnail */}
        <Avatar
          src={getThumbnailUrl()}
          sx={{ width: 30, height: 30, mt: 1 }}
        >
          {getThumbnailFallback()}
        </Avatar>

        {/* Content */}
        <Box sx={{ flex: 1, mx: 1 }}>
          <Typography
            variant="body2"
            sx={{ cursor: 'pointer' }}
            onClick={(e) => {
              e.stopPropagation();
              handleEventClick(e);
            }}
          >
            {`${formatDateTime(item.begin_time)} • ${item.event_name}${item.user ? ` • ${item.user.name}` : ''}${item.executed ? t('agenda.done') : ''}`}
          </Typography>

          {item.pet && (
            <Typography 
              variant="body2" 
              color="text.secondary"
              sx={{ 
                cursor: 'pointer',
                display: 'block',
                width: 'fit-content',
                '&:hover': { textDecoration: 'underline' }
              }}
              onClick={handlePetClick}
            >
              {item.pet.name}
            </Typography>
          )}

          {item.owner && (
            <Typography 
              variant="body2" 
              color="text.secondary"
              sx={{ 
                cursor: 'pointer',
                display: 'block',
                width: 'fit-content',
                '&:hover': { textDecoration: 'underline' }
              }}
              onClick={handleOwnerClick}
            >
              {t('layouts.fromOwner')} {item.owner.name}
            </Typography>
          )}
        </Box>

        {/* Actions */}
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          {!item.executed && (
            <>
              <IconButton
                size="small"
                onClick={handlePostponeClick}
                sx={{ p: 1 }}
              >
                <ArrowForwardIcon />
              </IconButton>

              <IconButton
                size="small"
                onClick={handleCompleteClick}
                sx={{ p: 1 }}
                color="default"
              >
                <CheckIcon />
              </IconButton>
            </>
          )}
        </Box>
      </Box>
      {/* <Divider sx={{ mt: 1 }} /> */}
    </Box>
  );
}

export default MainAgendaListItem;
